import type { EventManagerEvents } from '../EventManager';

import { _fakeMessage } from '../Communication';

export function registerDebugEventManager() {
    window.addEventListener('online', () => {
        const event: EventManagerEvents = {
            action: 'network_error',
            arguments: {
                retry: true,
            }
        };

        _fakeMessage({
            transaction_id: -1,
            type: 'event',
            ...event,
        });
    });
}